// extracted by mini-css-extract-plugin
module.exports = {"root":"ShoppingWidget1_root__uka__","arrows":"ShoppingWidget1_arrows__AryHp","arrowNext":"ShoppingWidget1_arrowNext__cbkOe","arrowPrev":"ShoppingWidget1_arrowPrev__L8Wr6"};